import Vue from 'vue'
import store from '../store/index'
import router from '../router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

axios.defaults.withCredentials = true;

axios.interceptors.request.use(config => {
  config.baseURL = process.env.VUE_APP_BASE_URL
  config.headers.common['Access-Control-Allow-Origin'] = '*'
  config.headers.common['X-Requested-With'] = 'XMLHttpRequest'
  config.headers.common['Content-Type'] = 'application/json'
  config.headers.common.Accept = 'application/json'
  // add token if exist
  let token = store.getters['getAuthToken']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => Promise.reject(err))

axios.interceptors.response.use(
  response => response,
  error => {
    const vm = new Vue()

    if (error.response) {
      let status = error.response.status

      switch (status) {
        case 401:
          store.commit('CLEAR_STORAGE')
          if(router.currentRoute.name !== 'Login') {
            router.push({name: 'Login'})
          }
          break
        // case 404:
        //   if(router.currentRoute.name !== 'E404') {router.push({name: 'E404'})}
        //   break
        case 403:
          vm.$notify("Access deny", 'error')
          break
        case 422:
          vm.$notify("Check the entry", 'error')
          break
        case 429:
          vm.$notify('Too many requests', 'error')
          break
        case 503:
          if(router.currentRoute.name !== 'E503') {
            router.push({name: 'E503'})
          }
          break
        default:
          vm.$notify(`Something went wrong`, 'error')
      }
    }

    return Promise.reject(error)
  },
)
